import { convertFromRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import { isSafeAddress } from 'helpers/richTextAddress'
import { documentHasContent, draftDocument } from 'helpers/richTextDocument'
import { tenis10CategoryLabel } from '../../../tenis10Event'

export const notificationEnabled = value => value === true || value === 'true'
export const announcementActive = announcement => ['PENDING', 'ENABLED'].includes(announcement?.status)

export function readAnnouncementContent(message) {
  if (!message) return { valid: true, text: '', html: '', hasContent: false }
  try {
    const raw = draftDocument(message)
    if (!raw) throw new Error('Invalid content')
    // Draft escapes text; restrict link/media URLs before rendering entity attributes.
    for (const entity of Object.values(raw.entityMap)) {
      if (entity?.data) for (const key of ['url', 'href', 'src']) {
        if (entity.data[key] && !isSafeAddress(entity.data[key])) entity.data[key] = ''
      }
    }
    const content = convertFromRaw(raw)
    return { valid: true, text: content.getPlainText('\n'), html: stateToHTML(content), hasContent: documentHasContent(raw) }
  } catch {
    return { valid: false, text: '', html: '', hasContent: false }
  }
}

export function announcementCompetition(id, competitions = []) {
  const competition = competitions.find(item => String(item.competitionId) === String(id))
  if (!competition || competition.status === 'DELETED') return { value: id, label: `Competition #${id} · unavailable`, isDisabled: true }
  const status = competition.status === 'DISABLED' ? ' · Disabled' : competition.status === 'MAINTENANCE' ? ' · Maintenance' : ''
  // A Tenis10 competition is its category, its level 4 only the model's default (register E35).
  const name = competition.tenis10Level ? tenis10CategoryLabel(competition) : `${competition.level}${competition.gameType === 'singles' ? 'S' : 'D'}`
  return { value: competition.competitionId, label: `${name} #${id}${status}`, isDisabled: competition.status === 'DISABLED' }
}
